import { ReactElement } from "react";
import { CellComponentProps } from "react-window";

import { DateYMDString, ICoursesCalendarSlotDto } from "@ryde/shared";

import { CoursesCalendarTableBodyCell } from "./calendar-cell";
import { CoursesCalendarCornerCell } from "./courses-calendar.corner-cell";
import { CoursesCalendarDateHeadCell } from "./courses-calendar.head-date";
import { CoursesCalendarHourLabelCell } from "./courses-calendar.hour-label";

export interface ICoursesCalendarGridData {
  dateKeys: DateYMDString[];
  /** Body row order: actual hour indices 0–24 (subset when “rows only with courses”). */
  visibleHourIndices: number[];
  slotMap: Map<string, ICoursesCalendarSlotDto[]>;
  onCreateSlotRide: (slot: ICoursesCalendarSlotDto) => Promise<number>;
  onAfterSlotProduce?: () => void;
}

export const CoursesCalendarCellRenderStrategy = ({
  style,
  rowIndex,
  columnIndex,
  data,
}: CellComponentProps<ICoursesCalendarGridData> & {
  data: ICoursesCalendarGridData;
}): ReactElement => {
  const {
    dateKeys,
    visibleHourIndices,
    slotMap,
    onCreateSlotRide,
    onAfterSlotProduce,
  } = data;
  if (rowIndex === 0 && columnIndex === 0) {
    return <CoursesCalendarCornerCell style={style} />;
  }

  if (rowIndex === 0) {
    return (
      <CoursesCalendarDateHeadCell
        style={style}
        columnIndex={columnIndex - 1}
        dateKeys={dateKeys}
      />
    );
  }

  if (columnIndex === 0) {
    const rowHourIndex = visibleHourIndices[rowIndex - 1]!;
    return (
      <CoursesCalendarHourLabelCell style={style} hourIndex={rowHourIndex} />
    );
  }

  const hourIndex = visibleHourIndices[rowIndex - 1]!;

  return (
    <CoursesCalendarTableBodyCell
      style={style}
      dateKey={dateKeys[columnIndex - 1]}
      hourIndex={hourIndex}
      slotMap={slotMap}
      onCreateSlotRide={onCreateSlotRide}
      onAfterSlotProduce={onAfterSlotProduce}
    />
  );
};
